import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { EXPRESS_API } from 'configs/api/expressApi';

type Body = {
  organizationVideoId: number;
};

const importOrganizationVideo = async (body: Body) => {
  return await EXPRESS_API.post(`/organization-videos`, { ...body });
};

export const useOrganizationVideoImportMutation = ({
  onSuccesCallback,
}: {
  onSuccesCallback: () => void;
}) => {
  const { t } = useTranslation();
  const { showError } = useToastError();
  return useMutation(importOrganizationVideo, {
    onSuccess: () => {
      successToast({ title: t('Video has been added!') });
      onSuccesCallback();
    },
    onError: error =>
      showError(error, t('An error occured while trying to add the video!')),
  });
};
